var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StepLayout } from '@/components/step-layout.component';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { useNavigator } from 'hx-navigator';
import { OverLayBanner } from '@/components/overlay-banner.component';
import { useDispatch, useSelector } from 'react-redux';
import { dinTestActions } from '@/store';
import { isResultsCategory } from '@/components/results-category/helpers/is-results-category.helper';
import { ErrorMessage } from '@/components/error-message.component';
import { NavigationButton, } from '@/components/navigation-button.component';
import { Disclaimer } from '@/components/results-category/components/disclaimer.component';
import { useTestCompletionCallback } from '@/hooks/use-test-completion-callback.hook';
import { createWizardStore } from 'hx-wizard';
import { createWidgetStore } from 'hx-widget-store';
export default function ResultCategoryPage() {
    var _a = useState(''), image = _a[0], setImage = _a[1];
    var _b = useState(0), setStep = _b[1];
    var navigate = useNavigator().navigate;
    var location = useLocation();
    var handleTestCompletion = useTestCompletionCallback();
    var dispatch = useDispatch();
    var wizardActions = createWizardStore().wizardActions;
    var widgetActions = createWidgetStore().widgetActions;
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    useEffect(function () {
        if (category && !location.pathname.includes(category)) {
            handleTestCompletion();
            navigate("/result-category/".concat(category));
        }
    }, [category]);
    if (!category || !isResultsCategory(category)) {
        return (_jsx(ErrorMessage, { action: function () { return navigate('/'); }, actionText: "Retake Test", message: "Oops! Cannot display results" }));
    }
    function handleEndSessionClick() {
        dispatch(dinTestActions.reset());
        dispatch(wizardActions.reset());
        dispatch(widgetActions.startNewSession());
        navigate('/');
    }
    return (_jsx(StepLayout, { progress: { phase: 2, step: 4 }, overlayedContent: _jsx(OverLayBanner, { content: _jsx(Disclaimer, {}), className: "bg-norc-orange-dark text-center text-xl text-white py-3" }), image: image, content: _jsx(Outlet, { context: {
                setImage: setImage,
                setStep: setStep,
            } }), nav: _jsxs("div", __assign({ className: 'flex flex-col gap-8 items-center justify-center py-2 mb-2' }, { children: [_jsx(Disclaimer, {}), _jsx(NavigationButton, __assign({ variant: "outlined", onClick: handleEndSessionClick, className: 'text-center uppercase' }, { children: "End session" }))] })) }));
}
export function ResultCategoryOutlet() {
    return _jsx(Outlet, { context: useResultCategoryOutletContext() });
}
